import React from 'react'

import MuiToggleButton from '@mui/material/ToggleButton'
import MuiToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { styled } from '@mui/material/styles'

import { color } from 'styles/colors'
import { screenSize, focusOutline } from 'styles/shared'

type Props = {
  values: Array<{ key: string | number, displayValue: string}>
  onChange: (value: string | number) => void,
  selectedValue: string | number
}

const ToggleButtonGroup = ({ values, onChange, selectedValue }: Props) => {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, newSelectedValue: string | number | null) => {
    if (newSelectedValue) {
      onChange(newSelectedValue)
    }
  }

  return (
    <MuiToggleButtonGroup
      value={selectedValue}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
    >
      {values.map((value) => <S.MuiToggleButton disableRipple key={value.key} value={value.key}>{value.displayValue}</S.MuiToggleButton>)}
    </MuiToggleButtonGroup>
  )
}

export default ToggleButtonGroup

const S = {
  MuiToggleButton: styled(MuiToggleButton)({
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    color: color('siteMessageStatusDisabledText'),
    fontWeight: 'bold',

    '&.Mui-selected': {
      color: color('selectedRthLegendControl'),
      backgroundColor: color('rthLegendControlBackground')
    },

    '&:hover': {
      color: color('selectedRthLegendControl'),
      backgroundColor: color('rthChartIconHoverBackground'),
      cursor: 'hand'
    },

    [`@media ${screenSize.small}`]: {
      fontSize: '12px'
    },

    '&:focus': {
      outline: focusOutline({ executable: true, focusOutlineValueOnly: true })
    }
  })
}
